import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import cvData from '../data/data.json';

const Footer = () => {
  const { personalInfo } = cvData;

  return (
    <footer style={{
      backgroundColor: '#0a192f',
      color: '#8892b0',
      padding: '3rem 0',
      borderTop: '1px solid rgba(100, 255, 218, 0.1)'
    }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <h3 style={{ 
              color: '#ccd6f6', 
              marginBottom: '2rem',
              fontSize: '1.5rem'
            }}>
              Get In Touch
            </h3>
            <p style={{ 
              marginBottom: '2rem',
              fontSize: '1.1rem',
              lineHeight: '1.6'
            }}>
              Whether you have a question or just want to say hi, my inbox is always open.
            </p>
            <div style={{ marginBottom: '2rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <MdEmail style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                <a href={`mailto:${personalInfo.email}`} style={{ color: '#64ffda', textDecoration: 'none' }}>
                  {personalInfo.email}
                </a>
              </div>
              <div>
                <MdLocationOn style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                <span>{personalInfo.location}</span>
              </div>
            </div>
            {/* <div style={{ marginTop: '2rem', fontSize: '0.9rem' }}>
              <p>© {new Date().getFullYear()} {personalInfo.name} {personalInfo.surname}.</p>
            </div> */}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer; 